import { createUseStyles } from 'react-jss'

const useSidebarLogoStyles = createUseStyles({
  logoWrapper: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
    padding: 15,
    zIndex: -1,

    '& > img': {
      width: '100%',
      height: 'auto',
      display: 'block'
    }
  }
})

export { useSidebarLogoStyles }
